<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >ข้อมูลยื่นคำร้อง</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgentInfo"
                >ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              ขอเปลี่ยนแปลงที่อยู่
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->

  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgentAddress">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอเปลี่ยนแปลงที่อยู่
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content font-family">
        <div class="d-none d-lg-flex align-items-center">
          <div class="icon-back">
            <router-link to="/AgentAddress">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3 ps-lg-3
              d-block d-md-block d-lg-block
            "
          >
            ขอเปลี่ยนแปลงที่อยู่
          </div>
        </div>
        <div class="pb-3 mb-3 pb-lg-4 mb-lg-4">
          <div class="gray-3 fs-5 mb-2 mt-3">ที่อยู่เดิม</div>
          <div class="blue-1 fs-5 mb-2 mt-3">
             <div v-for="(address, index) in this.$store.state.AgentInfo.ADDRESS" :key="index">
              <div v-if="address.ADR_TYPE == this.$store.state.TypeAddressE" >
                {{ address.ADDRESS }} {{ address.POST }} <br />
                {{ address.TELEPHONE }}
              </div>
            </div>
          </div>
          <div class="shadow-none fs-5 p-3 mb-2 bg-light rounded">
            <div class="row">
              <div
                class="
                  d-block d-lg-block
                  col-12 col-md-12 col-lg-12
                  p-0
                  ps-lg-3
                  pe-lg-3
                "
              >
                <div class="form-group position-relative mb-0">
                  <input
                    type="radio"
                    name="tab"
                    id="livepaper"
                    class="form-check-input"
                    @click="ClickSelect(false)"
                  />

                  <label v-if="this.$store.state.TypeAddressE === 'H'" class="ms-1">ที่อยู่เดียวกันกับทะเบียนบ้าน</label>
                  <label v-else class="ms-1">ที่อยู่เดียวกันกับที่อยู่ติดต่อ</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="
                  d-block d-lg-block
                  col-12 col-md-12 col-lg-12
                  p-0
                  ps-lg-3
                  pe-lg-3
                "
              >
                <div class="form-group position-relative mb-0">
                  <input
                    type="radio"
                    name="tab"
                    id="normalpaper"
                    class="form-check-input"
                    @click="ClickSelect(true)"
                  />
                  <label class="ms-1">ระบุใหม่</label>
                </div>
              </div>
            </div>
          </div>
          <Transition name="fade">
            <div class="row fw-normal fs-5" v-if="livePaper">
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    ชื่อสถานที่
                    <input
                      type="text"
                      v-model="Name"
                      class="field__input a-field__input"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    เลขที่<span class="required">*</span>
                    <input
                      type="text"
                      v-model="HomeNumber"
                      class="field__input a-field__input fs-6"
                      style="font-family: monospace;"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    หมู่ที่
                    <input
                      type="text"
                      v-model="Mooh"
                      class="field__input a-field__input"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field" asp-for="Soi">
                    ตรอก/ซอย
                    <input
                      type="text"
                      v-model="Soi"
                      class="field__input a-field__input"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    ถนน
                    <input
                      type="text"
                      v-model="Road"
                      class="field__input a-field__input"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    ตำบล/แขวง<span class="required">*</span>
                    <input
                      type="text"
                      v-model="Tambol"
                      class="field__input a-field__input"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    อำเภอ/เขต<span class="required">*</span>
                    <input
                      type="text"
                      v-model="Amphur"
                      class="field__input a-field__input"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    จังหวัด<span class="required">*</span>
                    <input
                      type="text"
                      v-model="Province"
                      class="field__input a-field__input"
                      autocomplete="off"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field" asp-for="PostCode">
                    รหัสไปรษณีย์<span class="required">*</span>
                    <input
                      type="text"
                      v-model="PostCode"
                      class="field__input a-field__input fs-6"
                      style="font-family: monospace;"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      maxlength="5"
                    />
                  </label>
                  <span
                    asp-validation-for="PostCode"
                    class="text-danger"
                  ></span>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label class="field a-field page__field">
                    เบอร์โทรศัพท์
                    <input
                      type="text"
                      v-model="TelephoneNo"
                      class="field__input a-field__input fs-6"
                      style="font-family: monospace;"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    />
                  </label>
                  <span class="text-danger"></span>
                </div>
              </div>
            </div>
          </Transition>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button
              type="button"
              class="btn btn-light btn-cancel font-family d-inline-block"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
              <button
                type="button"
                class="btn btn-continue font-family d-inline-block"
                @click="EnterNext()"
              >
                ดำเนินการต่อ
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade font-family"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light fw-normal popup_cancel"
            data-bs-dismiss="modal"
          >
            ไม่ต้องการ
          </button>
          <router-link to="/AgentInfo">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal" @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "EditAddress",
  components: {
    Menu,
  },
  data() {
    return {
      livePaper: false,
      TypeAddress: '',
      AddressRegis: '',
      Name: "",
      HomeNumber: "",
      Mooh: "",
      Soi: "",
      Road: "",
      Tambol: "",
      Amphur: "",
      Province: "",
      PostCode: "",
      TelephoneNo: "",
      Post: "",
      AddressContact: '',
      PostContact: '',
      MobliePhoneHome: ''
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.forEach(item => {
      if(this.$store.state.TypeAddressE == item.ADR_TYPE && item.ADDRESS_CHANGE === 'N') {
        this.Name = item.ADDRESS_NAME;
        this.HomeNumber = item.ADDRESS_NUMBER;
        this.Mooh = item.MOOH;
        this.Soi = item.SOI;
        this.Road = item.ROAD;
        this.Tambol = item.TAMBOL;
        this.Amphur = item.AMPHUR;
        this.Province = item.PROVINCE;
        this.PostCode = item.ZIP_CODE;
        this.TelephoneNo = item.PHONE_NUMBER;

        this.livePaper = true;
        this.TypeAddress = "N";
        document.getElementById("normalpaper").checked = true;
      }
      else if(this.$store.state.TypeAddressE == item.ADR_TYPE && item.ADDRESS_CHANGE === 'T') {
        this.TypeAddress = "T";
        document.getElementById("livepaper").checked = true;
      }
      else {
        //document.getElementById("livepaper").checked = true;
      }
    });
  },
  methods: {
    EnterNext() {
      if(this.ValidateAddress()) {
        if(this.TypeAddress !== '') {
          this.$store.state.AgentInfo.ADDRESS.forEach(element => {
            if(element.ADR_TYPE === 'T') {
              this.AddressRegis = element.ADDRESS + " " + element.POST;
              this.Post = element.POST;
              this.MobliePhoneHome = element.TELEPHONE;
            }
            else {
              this.AddressContact = element.ADDRESS + " " + element.POST;
              this.PostContact = element.POST;
              this.MobliePhoneContact = element.TELEPHONE;
            }
          });
          let ED_ADDRESS = {
            ADDRESS_CHANGE: this.TypeAddress,
            ADDRESS_REGIS: (this.$store.state.TypeAddressE === 'T' && this.TypeAddress === 'T') ? this.AddressContact : this.AddressRegis,
            ADR_TYPE: this.$store.state.TypeAddressE,
            ADDRESS_NUMBER: this.HomeNumber,
            ADDRESS_NAME: this.Name,
            MOOH: this.Mooh,
            SOI: this.Soi,
            ROAD: this.Road,
            TAMBOL: this.Tambol,
            AMPHUR: this.Amphur,
            PROVINCE: this.Province,
            ZIP_CODE: (this.TypeAddress === 'N') ? this.PostCode : this.Post,
            PHONE_NUMBER: (this.TypeAddress === 'N') ? this.TelephoneNo : (this.$store.state.TypeAddressE === 'H') ? this.MobliePhoneHome : this.MobliePhoneContact
          };

          let length = this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.length;
          if(length > 0) { 
            const index = this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.findIndex(object => {
              return object.ADR_TYPE === this.$store.state.TypeAddressE; 
            });

            if(index >= 0) {
              this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.splice(index, 1);
              this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.push(ED_ADDRESS);
            }
            else {
              this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.push(ED_ADDRESS);
            }
          }
          else {
            this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.push(ED_ADDRESS);
          }

          this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS = true;
        }
        else {
          let length = this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.length;
          (length > 0) ? this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS = true : this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS = false;
        }

        this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.forEach(item => {
          if(item.ADR_TYPE === 'H' && item.ADDRESS_CHANGE === 'N') {
            this.$store.state.AddressHome = item.ADDRESS_NAME + " " + item.ADDRESS_NUMBER + " " + 
            ((item.MOOH !== '') ? "หมู่." + item.MOOH : '') + " " + 
            ((item.SOI !== '') ? "ซ." + item.SOI : '') + " " +
            ((item.ROAD !== '') ? "ถ." + item.ROAD : '') + " " +
            "ต." + item.TAMBOL + " " +
            "อ." + item.AMPHUR + " " +
            "จ." + item.PROVINCE + " " + item.ZIP_CODE;
            this.$store.state.AddressHomeTele = item.PHONE_NUMBER;
          }
          else if(item.ADR_TYPE === 'H' && item.ADDRESS_CHANGE === 'T') {
            this.$store.state.AddressHome = this.AddressRegis;
            this.$store.state.AddressHomeTele = item.PHONE_NUMBER;
          }
          else if (item.ADR_TYPE === 'T' && item.ADDRESS_CHANGE === 'N') {
            this.$store.state.AddressCont = item.ADDRESS_NAME + " " + item.ADDRESS_NUMBER + " " + 
            ((item.MOOH !== '') ? "หมู่." + item.MOOH : '') + " " + 
            ((item.SOI !== '') ? "ซ." + item.SOI : '') + " " +
            ((item.ROAD !== '') ? "ถ." + item.ROAD : '') + " " +
            "ต." + item.TAMBOL + " " +
            "อ." + item.AMPHUR + " " +
            "จ." + item.PROVINCE + " " + item.ZIP_CODE;
            this.$store.state.AddressContTele = item.PHONE_NUMBER;
          }
          else if(item.ADR_TYPE === 'T' && item.ADDRESS_CHANGE === 'T') { 
            this.$store.state.AddressCont = this.AddressContact;
            this.$store.state.AddressContTele = this.MobliePhoneContact;
          }
        });

        this.$router.push('/AgentAddress');
      }
    },
    ClickSelect(bool) {
      this.livePaper = bool;
      if(bool) {
        this.TypeAddress = "N";
      }
      else {
        this.TypeAddress = "T";
      }
    },
    ClearData() {
      this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS = [];
      this.$store.state.AddressHome = '';
      this.$store.state.AddressHomeTele = '';
      this.$store.state.AddressRegis = '';
      this.$store.state.AddressRegisTele = '';
      this.$store.state.AddressCont = '';
      this.$store.state.AddressContTele = '';
      this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS = false;
    },
    ValidateAddress(){
      if(this.TypeAddress === 'N') {
        if(this.HomeNumber === '') { 
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">กรุณากรอก บ้านเลขที่</lable>',
          });
          return false;
        }
        else if(this.Amphur === '') {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">กรุณากรอก อำเภอ/เขต</lable>',
          });
          return false;

        }
        else if(this.Tambol === '') {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">กรุณากรอก ตำบล/แขวง</lable>',
          });
          return false;
        }
        else if(this.Province === '') {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">กรุณากรอก จังหวัด</lable>',
          });
          return false;
        }
        else if(this.PostCode === '') {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">กรุณากรอก รหัสไปรษณีย์</lable>',
          });
          return false;
        }
        else {
          return true;
        }
      }
      else {
        // ADDRESS_CHANGE: this.TypeAddress,
        //     ADDRESS_REGIS: (this.$store.state.TypeAddressE === 'T' && this.TypeAddress === 'T') ? this.AddressContact : this.AddressRegis,
        //     ADDRESS_TYPE: this.$store.state.TypeAddressE,
        //     ADDRESS_NUMBER: this.HomeNumber,
        // this.Name = '';
        //     MOOH: this.Mooh,
        //     SOI: this.Soi,
        //     ROAD: this.Road,
        //     TAMBOL: this.Tambol,
        //     AMPHUR: this.Amphur,
        //     PROVINCE: this.Province,
        //     ZIP_CODE: (this.TypeAddress === 'N') ? this.PostCode : this.Post,
        // this.TelephoneNo = '';
        return true;
      }
    }
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>